/* global toastr */
import React from 'react'
import { wrapView, request } from '../smart_bps/lib/utils'
import { stateToPropsSigur } from '../lib/stateToPropsSigur'
import { PROJECT_NAME } from './constants'
import { SigurModelView } from '../lib/SigurModelView'
import AttrInput from '../smart_bps/lib/attr_input'
import { Panel } from '../smart_bps/lib/components'

/**
 * Дата начала + тип задачи с «Срок выполнения (в днях)» в админке →
 * автоматически «Срок выполнения до» = дата начала + дни (и на фронте сразу, без сохранения).
 */
function addDaysToIsoDate(isoDateStr, days) {
  if (!isoDateStr || days == null || days <= 0) return null
  const s = String(isoDateStr).slice(0, 10)
  const d = new Date(s + 'T12:00:00')
  if (Number.isNaN(d.getTime())) return null
  d.setDate(d.getDate() + Number(days))
  return d.toISOString().slice(0, 10)
}

class ModelView extends SigurModelView {
  constructor(props) {
    super(props)
    this.state = {
      ...this.state,
      showRefuseContractRegModal: false,
      refuseReasonText: '',
    }
    this.formChange = this.formChange.bind(this)
    this.registrationAction = this.registrationAction.bind(this)
    this.openRefuseContractRegModal = this.openRefuseContractRegModal.bind(this)
    this.closeRefuseContractRegModal = this.closeRefuseContractRegModal.bind(this)
    this.sendRefuseReasonOnEmail = this.sendRefuseReasonOnEmail.bind(this)
    this.renderRefuseContractRegModal = this.renderRefuseContractRegModal.bind(this)
    this.fileBlockRef = React.createRef()
  }

  formChange(name, value, cb) {
    const that = this
    const form_errors = { ...this.state.form_errors, [name]: undefined }
    let form_data = { ...this.state.form_data, [name]: value }

    // Дата начала или смена названия (типа) — пересчитать deadline при наличии дней в типе
    const tryApplyDeadlineFromStartDate = (startDate, nextFormData) => {
      const taskTypeId =
        nextFormData.task_type_id != null
          ? nextFormData.task_type_id
          : typeof nextFormData.title === 'number'
            ? nextFormData.title
            : typeof nextFormData.title === 'string' && /^\d+$/.test(nextFormData.title)
              ? parseInt(nextFormData.title, 10)
              : null
      if (taskTypeId == null || Number.isNaN(Number(taskTypeId)) || !startDate) {
        that.setState({ form_data: nextFormData, form_errors }, cb)
        return
      }
      request({
        method: 'get',
        url: `/api/tasks/task_type_info?task_type_id=${taskTypeId}`,
        success: (info) => {
          const days = info && info.deadline_days
          if (days != null && days > 0) {
            const deadline = addDaysToIsoDate(startDate, days)
            if (deadline) {
              that.setState(
                {
                  form_data: { ...nextFormData, deadline },
                  form_errors: { ...form_errors, deadline: undefined },
                },
                cb
              )
              return
            }
          }
          that.setState({ form_data: nextFormData, form_errors }, cb)
        },
        error: () => that.setState({ form_data: nextFormData, form_errors }, cb),
      })
    }

    if (name === 'start_date' && value) {
      tryApplyDeadlineFromStartDate(value, form_data)
      return
    }
    if (name === 'title' && value != null) {
      const startDate = form_data.start_date
      if (startDate) {
        tryApplyDeadlineFromStartDate(startDate, form_data)
        return
      }
    }

    this.setState({ form_data, form_errors }, cb)
  }

  // Скрываем кнопку "Редактировать все"; «Что дальше?» — справа.
  renderContentLeftActionRightItems() {
    return [this.renderOtherEventsButton()]
  }

  openRefuseContractRegModal() {
    this.setState({
      showRefuseContractRegModal: true,
    })
  }

  isRegistrationDecisionAvailable(approveType) {
    const can_reg_key = `can_registration_decision_${approveType}`
    const is_can_reg = this.state[can_reg_key]

    if (typeof is_can_reg === 'boolean') {
      return is_can_reg
    }
    const formData = this.state.form_data || {}
    const taskTypeIdRaw = formData.task_type_id ?? formData.title
    const taskTypeId = Number(taskTypeIdRaw)
    return Number.isFinite(taskTypeId) && taskTypeId > 0
  }

  closeRefuseContractRegModal() {
    this.setState({ showRefuseContractRegModal: false, refuseReasonText: ''})
  }

  updateUserPhone = (name, value, userId) => {
    let digits = value.replace(/\D/g, '').slice(0, 11)

    if (digits.length > 0 && digits[0] !== '7') {
      digits = '7' + digits.slice(1)
    }

    let display = '+7'
    if (digits.length > 1) display += ' (' + digits.slice(1, 4)
    if (digits.length >= 4) display += ') ' + digits.slice(4, 7)
    if (digits.length >= 7) display += '-' + digits.slice(7, 9)
    if (digits.length >= 9) display += '-' + digits.slice(9, 11)

    this.formChangeForAccessUsers(name, display, userId)
  }

  handleRegistrationResponse(data, onSuccess) {
    if (data.errors) {
      this.setState({ form_errors: data.errors })
      const msg = data.errors.contractor_reg_form_email
      if (msg) {
        toastr.warning(msg, 'Внимание')
      }
      return
    }
    if (onSuccess) onSuccess(data)
  }

  registrationAction(type) {
    if (type === 'rejected') {
      this.openRefuseContractRegModal()
      return null
    }

    const that = this
    request({
      method: 'post',
      url: `/api/tasks/${this.object_id}/registration_approved`,
      success: (data) => that.handleRegistrationResponse(data, () => {
        toastr.success(`На почты сотрудников подрядчика отправлены письма для регистрации.`)
        that.documentToState(data)
      }),
      error: (err) => {
        const detail = err && (err.detail?.detail || err.detail)
        toastr.error(detail || 'Операция не выполнена')
      },
    })
  }

  sendRefuseReasonOnEmail() {
    const { refuseReasonText } = this.state

    if (!refuseReasonText) {toastr.error('Укажите причину отказа'); return null }

    const that = this
    request({
      method: 'post',
      url: `/api/tasks/${this.object_id}/registration_rejected`,
      data: { refuse_reason: refuseReasonText.trim() },
      success: (data) => that.handleRegistrationResponse(data, () => {
        toastr.success(`На почты сотрудников подрядчика отправлены письма с причиной отказа в регистрации.`)
        that.documentToState(data)
        that.closeRefuseContractRegModal()
      }),
      error: (err) => {
        const detail = err && (err.detail?.detail || err.detail)
        toastr.error(detail || 'Операция не выполнена')
      },
    })
  }

  renderNotifications() {
    const base = super.renderNotifications ? super.renderNotifications() : []
    const emailErr = this.state.form_errors && this.state.form_errors.contractor_reg_form_email
    if (!emailErr) {
      return base
    }
    const email = this.state.contractor_reg_form_email
    const text = email
      ? `Email заявки на регистрацию (${email}): ${emailErr}`
      : emailErr
    return [
      <div key="contractor_reg_form_email_error" className="alert alert-danger mb-2">
        {text}
      </div>,
      ...base,
    ]
  }

  renderRefuseContractRegModal() {
    const {
      showRefuseContractRegModal
    } = this.state

    if (!showRefuseContractRegModal) {
      return null
    }

    return (
        <div
        className="modal fade show"
        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
        key="refuse_contract_reg_modal"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Отказ в регистрации</h5>
              <button type="button" className="btn-close" onClick={this.closeRefuseContractRegModal}></button>
            </div>
            <div className="modal-body">
              <AttrInput
                data_type="text"
                name="refuse_reason"
                access="edit"
                onChange={(name, value) => { this.setState({ refuseReasonText: value }) }}
                value={this.state.refuseReasonText || ""}
                placeholder="Укажите причину отказа (будет отправлена подрядчику на e-mail)"
              />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={this.closeRefuseContractRegModal}>
                Отмена
              </button>
              <button type="button" className="btn btn-primary" onClick={this.sendRefuseReasonOnEmail}>
                Отправить
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderContentRight() {
    if (this.object_id === 0) {
      return []
    }
    const filesSchema = this.state.files_schema || []
    const blocks = [this.renderInfo()]
    if (filesSchema.length > 0) {
      blocks.push(
        this.renderFileBlock(true)
      )
    }
    blocks.push(this.renderComments())
    return blocks
  }

  renderContentLeftActionLeftItems() {
    const base = super.renderContentLeftActionLeftItems().filter(Boolean);

    let rejectedBtn = null;
    let approvedBtn = null;

    if (this.isRegistrationDecisionAvailable('reject')) {
      rejectedBtn = (
        <span
          key="registration_rejected"
          className="btn btn-outline-danger waves-effect p-2"
          onClick={() => this.registrationAction('rejected')}
        >
          Отказ в регистрации
        </span>
      );
    }

    if (this.isRegistrationDecisionAvailable('approve')) {
      approvedBtn = (
        <span
          key="registration_approved"
          className="btn btn-outline-success waves-effect p-2"
          onClick={() => this.registrationAction('approved')}
        >
          Регистрация одобрена
        </span>
      );
  }

  const deleteIdx = base.findIndex(item => item?.key === 'delete');
  const insertAt = deleteIdx >= 0 ? deleteIdx + 1 : base.length;

  const buttonsToInsert = [approvedBtn, rejectedBtn].filter(Boolean);

  return [
    ...base.slice(0, insertAt),
    ...buttonsToInsert,
    ...base.slice(insertAt)
  ];
}

  componentDidUpdate(prevProps, prevState, snapshot) {
    super.componentDidUpdate(prevProps, prevState, snapshot)

    const desc = document.querySelector('textarea[name="description"]')

    if (!desc) return
    desc.style.height = '250px'
  }

  renderModals() {
    const modals = super.renderModals ? super.renderModals() : []
    return [...modals, this.renderRefuseContractRegModal()]
  }

  renderFormGroupInclude(item, position) {
    const tabTitle = item[0]
    if (tabTitle === 'Основное' && position === 'bottom' && this.state.is_registration_task) {
      return <React.Fragment key="current_access">{this.renderCurrentAccessTable()}</React.Fragment>
    }
    return null
  }

  formChangeForAccessUsers = (name, value, userId) => {
    this.setState(prevState => ({
      form_data: {
        ...prevState.form_data,
        for_access_users: {
          ...prevState.form_data.for_access_users,
          [userId]: {
            ...prevState.form_data.for_access_users[userId],
            [name]: value,
          },
        },
      },
    }))
  }

  renderAccessField(field, userData, userId) {
    const { form_access, form_errors } = this.state

    const changeHandlerName =
      field.change_handler || "formChangeForAccessUsers"

    return (
      <div className={form_errors?.[userId]?.[field.name] && "sigur-warning-board"}>
        <AttrInput
          {...field}
          title=''
          access={form_access[field.name]}
          value={userData?.[field.name] ?? (field.data_type === "m2m_integer" ? [] : "")}
          onChange={(name, value) =>
            this[changeHandlerName](name, value, userId)
          }
        />
      </div>
    )
  }

  renderCurrentAccessTable() {
    const { for_access_users } = this.state.form_data
    const fields = this.props.attrs.for_access_users_fields || []

    return (
      <Panel
        header="Пользователи, которым требуется доступ"
        key="current_access_panel"
      >
        <div className="table-responsive">
          <table className="table table-sm table-bordered table-hover align-middle">
            <thead className="bg-light text-nowrap">
              <tr>
                {fields.map(field => (
                  <th key={field.name} style={{ width: field.width}}>
                    {field.title}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {Object.entries(for_access_users || {}).map(([userId, userData], idx) => (
                <tr key={userId || idx}>
                  {fields.map(field => (
                    <td key={field.name} className="p-2">
                      {this.renderAccessField(field, userData, userId)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Panel>
    )
  }
}

export default wrapView(ModelView, (state) => stateToPropsSigur(state, PROJECT_NAME))
